import React, { useMemo } from 'react';
import useHolidayCoupon from '../../hooks/useHolidayCoupon';
import { useLocation } from 'react-router-dom';
import { DAYS } from '../../utils/variables';
import styles from './HolidayBanner.module.scss';

const formatEndDate = (coupon) => {
  if (!coupon.endDate) return null;

  const dateObject = new Date(`${coupon.endDate}T12:00:00+00:00`);

  const dayOfWeek = dateObject.getDay();
  const currentDay = new Date().getDay();

  if (dayOfWeek === currentDay) return 'Today';

  return DAYS[dayOfWeek];
};

export default function HolidayBanner() {
  const { data: coupon, isLoading } = useHolidayCoupon();
  // TODO: display based on location
  const location = useLocation();

  const shouldDisplay = useMemo(() => (
    ['review', 'gifts/builder']
      .some((substring) => location.pathname.includes(substring))
  ), [location.pathname]);

  if (isLoading || !coupon) return null;
  if (!shouldDisplay) return null;

  const formattedEndDate = formatEndDate(coupon);

  return (
    <></>
    // <div className={styles.holidayBanner}>
    //   <span>{`${coupon.value}% OFF`}</span>
    //   <span> | Use Code: </span>
    //   <span>{coupon.code}</span>
    //   {formattedEndDate && <span>{` ENDS ${formattedEndDate.toUpperCase()}`}</span>}
    // </div>
  );
}
